<template>
    <VeeForm @submit="addHorse" v-slot="{ errors, isSubmitting }">
        <div class="pedigree-add-horse flex flex-column gap-4 p-3 pb-5">
            <CustomInputText
                name="name"
                :label="$t('message.horseEdit.main.pedigree.name')"
                required
                v-model="horse.name"
                noPlaceholder
                rules="required"
                force-uppercase/>

            <CustomSelectOneHorseSex
                name="sex"
                :label="$t('message.horseEdit.main.pedigree.gender')"
                :disabled="true"
                v-model="horse.sex"
                noPlaceholder
                required
                rules="required"/>

            <CustomSelectOneHorseColor
                name="colorId"
                :label="$t('message.horseEdit.main.pedigree.coatColor')"
                v-model="horse.color"
                noPlaceholder/>

            <CustomCalendar
                name="dateOfBirth"
                :label="$t('message.horseEdit.main.pedigree.dateOfBirth')"
                v-model="horse.dateOfBirth"
                class="w-full"
                :max-date="today"/>

            <CustomInputText
                name="ueln"
                :label="$t('message.horseEdit.main.pedigree.ueln')"
                v-model="horse.ueln"
                noPlaceholder
                :max-length="15"/>

            <CustomSelectOneCountry
                name="countryOfBirthId"
                :label="$t('message.horseEdit.main.pedigree.countryOfBirth')"
                v-model="horse.countryOfBirthId"
                itemValue="id"
                filter
                />

            <div v-if="addHorseAnyway" class="flex justify-content-center mt-3">
                <CustomButton
                    type="submit"
                    :label="$t('message.horseEdit.main.pedigree.addButtonAnyway')"
                    :disabled="isSubmitting"/>
            </div>
            <div v-else class="flex justify-content-center mt-3">
                <CustomButton
                    type="submit"
                    :label="$t('message.horseEdit.main.pedigree.addButton')"
                    :disabled="isSubmitting"/>
            </div>
        </div>
    </VeeForm>
</template>

<script>
import CustomButton from "@/components/form/CustomButton.vue";
import Toast from "primevue/toast";
import CustomInputTextArea from "@/components/form/CustomInputTextArea.vue";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomSelectOne from "@/components/form/inner/CustomSelectOne.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox.vue";
import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
import CustomSelectOneHorseSex from "@/components/form/CustomSelectOneHorseSex.vue";
import CustomSelectOneHorseColor from "@/components/form/CustomSelectOneHorseColor.vue";
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import CustomCalendar from "@/components/form/CustomCalendar.vue";
import {
    addExternalHorse,
    searchSimpleHorse,
} from "@/swagger/vue-api-client";
import { Form as VeeForm } from 'vee-validate';
import CustomSelectOneCountry from "@/components/form/CustomSelectOneCountry.vue";

export default {
    name: "PedigreeAddHorseForm",
    components: {
        CustomSelectOneCountry,
        CustomCalendar,
        CustomTextButton,
        CustomSelectOneHorseColor,
        CustomSelectOneHorseSex,
        CustomInputNumber,
        CustomCheckbox,
        CustomSelectOne,
        CustomInputText,
        CustomInputTextArea,
        CustomButton,
        Toast,
        VeeForm
    },

    props: {
        horseSex: {
            required: true,
        },
    },

    data() {
        return {
            horse: {
                name: null,
                sex: null,
                color: null,
                dateOfBirth: null,
                ueln: null,
            },
            similarHorses: [],
            addHorseAnyway: false,
        };
    },

    mounted() {
        this.horse.sex = this.horseSex;
    },

    emits: ["addHorse", "showExistDialog"],

    methods: {
        async addHorse() {
            await searchSimpleHorse({body: {...this.horse, colorId: this.horse.color, horseBreed: localStorage.getItem("horseBreed")}})
                .then((response) => {
                    this.similarHorses = response.data;
                });
            if (!this.addHorseAnyway && this.similarHorses.length > 0) {
                this.$emit("showExistDialog", this.similarHorses);
                this.addHorseAnyway = true;
            } else {
                try {
                    const response = await addExternalHorse({body: this.horse});
                    this.$toast.add({
                        severity: "success",
                        summary: "Success",
                        detail: this.$t('message.horseEdit.main.pedigree.newHorseCreated'),
                        life: 3000,
                    });
                    this.$emit('addHorse', response.data);
                } catch (err) {
                    this.notifyError(err);
                }
            }
        },
        notifyError(error) {
            if (error.response?.data) {
                for (const [key, value] of Object.entries(error.response.data)) {
                    if (key !== "path" && key !== "status" && key !== "timestamp") {
                        this.$toast.add({
                            severity: "error",
                            summary: this.$t('message.other.error'),
                            detail: value,
                            life: 5000,
                        });
                    }
                }
            } else {
                this.$toast.add({
                    severity: "error",
                    summary: this.$t('message.other.error'),
                    detail: this.$t('unknownError'),
                    life: 5000,
                });
            }
        },
    },
    computed: {
        today() {
            return new Date();
        }
    },
    watch: {
        horse: {
            handler() {
                this.addHorseAnyway = false;
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
@import "../../../../../assets/theme/mytheme/variables";
.pedigree-add-horse {
    .custom-input-text, .custom-select-one, .custom-calendar {
        padding-left: 170px;

        .custom-label {
            z-index: 999;
            position: absolute;
            transform: translateX(-100%);
            left: 160px;
            text-align: right;
        }
    }
}
</style>
